import { Link, Box, Stack } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { LegalLinksLegacy } from '@dhl/legal'

import { useSignUpLink } from '~/appLinks'
import { TypographyDark } from './TypographyDark'
import { isFeatureEnabled } from '../config'

export const SignInFooter = () => {
  const { t } = useTranslation()
  const signUpLink = useSignUpLink()

  return (
    <Stack alignItems="center" spacing={1}>
      {isFeatureEnabled('signIn.c2cButton') && (
        <TypographyDark>
          <span>{t('account.signInFooter.noAccountYetText')} </span>
          <Link component={RouterLink} to={signUpLink} underline="always">
            {t('account.signInFooter.signUpButton')}
          </Link>
        </TypographyDark>
      )}
      {isFeatureEnabled('signIn.businessOnboardingLink') && (
        <TypographyDark>
          <span>{t('account.signInFooter.noAccountYetBusinessText')} </span>
          <Link
            href={t('account.signInFooter.signUpBusinessLink')}
            underline="always"
            data-test="sign-up-business-link"
          >
            {t('account.signInFooter.signUpButton')}
          </Link>
        </TypographyDark>
      )}
      <Box mt={1}>
        <LegalLinksLegacy singleLine />
      </Box>
    </Stack>
  )
}
